import React, { useEffect, useState } from "react";
import "./ApiBildirim.css";

// FE-77: ağ/sunucu hatasında kısa uyarı (utils/apiOturum.js "api-baglanti-hatasi" olayı). 7 sn sonra kapanır.
export default function ApiBildirim() {
  const [acik, setAcik] = useState(false);
  useEffect(() => {
    let t;
    const goster = () => {
      setAcik(true);
      clearTimeout(t);
      t = setTimeout(() => setAcik(false), 7000);
    };
    window.addEventListener("api-baglanti-hatasi", goster);
    return () => { window.removeEventListener("api-baglanti-hatasi", goster); clearTimeout(t); };
  }, []);
  if (!acik) return null;
  return (
    <div className="api-bildirim" role="alert">
      <span>Sunucuya ulaşılamadı; bazı bilgiler yüklenemedi. Bağlantınızı kontrol edip sayfayı yenileyin.</span>
      <button type="button" className="api-bildirim__kapat" aria-label="Kapat" onClick={() => setAcik(false)}>×</button>
    </div>
  );
}
